import { render, staticRenderFns } from "./basic-info.vue?vue&type=template&id=68e0e32d&scoped=true&"
import script from "./basic-info.vue?vue&type=script&lang=js&"
export * from "./basic-info.vue?vue&type=script&lang=js&"
import style0 from "./basic-info.vue?vue&type=style&index=0&lang=css&"
import style1 from "./basic-info.vue?vue&type=style&index=1&id=68e0e32d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e0e32d",
  null
  
)

export default component.exports